import { Component, OnInit } from '@angular/core';
import { MetadataService } from '../../../BaseFramework/core/http/metadata.service';
import { Router } from '@angular/router';
import { ApiRequestService, AppMetadataHandler, CommonUtilty, UserInfoService } from 'app';
import { NewBusinessAppSettings } from 'app/ViewModules/Newbusiness/newbusiness-configs';
import { environment } from 'environments/environment';
import configData from './search-receipt.component.json'
import { PolicyService } from 'app/FunctionalModules';
import moment from 'moment';
class SearchAPIMetaDataDO {
  key: any;
  keyDescription: any;
  valueInputType: any;
  lookupName: any;
  lookup: any;
  enable: true;
  isMandatory: Boolean;
}
@Component({
  selector: 'app-search-receipt',
  templateUrl: './search-receipt.component.html',
  styleUrls: ['./search-receipt.component.scss']
})
export class SearchReceiptComponent implements OnInit {
  getSearchCriteriaListArgument : string= 'searchReceipts'
  constructor(
    private metadataService: MetadataService,
    private router: Router,
    public apiRequestService: ApiRequestService,
    public userInfoService: UserInfoService,
    public newBusinessAppSettings: NewBusinessAppSettings,
    private commonUtilty: CommonUtilty,
    public policyService: PolicyService,
    public appMetadataHandler: AppMetadataHandler) { }

  ngOnInit() {
    this.getSearchCriteriaList();
    if (this.commonUtilty.isArrayIterable(environment['lob'])) {
      environment['lob'].forEach(lob => {
        this.tabArray = configData.LobBasedSearchArray.filter(item => item.productFamilyCd === lob)
      });
    }
    else
      this.tabArray = configData.LobBasedSearchArray;
    this.metadataService.getSearchCriteriaList(this.getSearchCriteriaListArgument).subscribe(resp => {
      this.CRITERIALOOKUP = this.commonUtilty.deepCopy(resp)
    });
    this.getLatestFiveProposals(this.tabArray[0].productFamilyCd);
    
    if(Array.isArray(this.dataSet) && this.dataSet.length) this.showNoData = true
  }

  showNoData = false;

  CRITERIALOOKUP = [];
  getSearchCriteriaList() {
    this.metadataService.fetchAPIMetaData('searchReceipts')
      .subscribe(jsonResp => {
        if (jsonResp && typeof jsonResp === typeof []) {
          jsonResp.forEach(criteria => {
            let searchCriteriaDO = new SearchAPIMetaDataDO();
            searchCriteriaDO.key = criteria.attributeName;
            searchCriteriaDO.keyDescription = criteria.description;
            searchCriteriaDO.valueInputType = criteria.attributeDataTypeCd;
            searchCriteriaDO.lookupName = criteria.attributeLookupCd;
            searchCriteriaDO.lookup = [];
            searchCriteriaDO.enable = true;
            searchCriteriaDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
            this.CRITERIALOOKUP.push(searchCriteriaDO)
          })
        }
      })
  }
  
  dataSet = [];

  fetchSearchResult($event){
    if ($event && !$event.reset) {
      if ($event && $event.results) {
        this.dataSet = $event.results;
        console.log(this.dataSet)
      }
      else this.dataSet = [];
    }
    else  this.getLatestFiveProposals(this.tabArray[0].productFamilyCd)
  }
  

  newReceipt(){
    this.router.navigate(['/app/nbu/proposal/receiptingForm']);
  }

  showReceipt: boolean = false;
  viewReceipt(guid){
    this.showReceipt = true;

    let pathVariables = [];
    pathVariables.push(guid || null);

    this.apiRequestService.getCallWithAPIMapper("policyFetchByGuid", null, null, pathVariables).subscribe(res=>{
    // this.apiRequestService.getCallWithAPIMapper("policyFetchByGuid" + guid).subscribe(res=>{
      if(res)
      {
        this.transactionDataIO = res;
      }

    })
  }

  closeReceipt(): void {
    this.showReceipt = false;
  }
  public tabArray = [];
  public productFamilyCd = null;
  itemsPerPage: any = 5;
  currentPage: any = 0;
  searchURL = "searchReceipt"
  getLatestFiveProposals(productFamilyCd) {
    this.productFamilyCd = productFamilyCd
    this.newBusinessAppSettings.APPCONSTANTS.productFamilyCd = this.productFamilyCd;
    var payload = {}
    payload["page"] = this.currentPage;
    payload["size"] = this.itemsPerPage;
    payload["searchCriteriaList"] = []
    var criteriaItem1 = {}
    var criteriaItem2 = {}
    let userId = null
    userId = this.userInfoService.getUserId();
    criteriaItem1 = {}
    criteriaItem1["paramName"] = 'criteriaUser'
    criteriaItem1["paramValue"] = userId
    payload["searchCriteriaList"].push(criteriaItem1)
    this.apiRequestService.postCallWithAPIMapper(this.searchURL, payload).subscribe(data => {
      this.dataSet = data.results;
    });
  }
  transactionDataIO: any = [];
proposalDataModal = 'Proposal Details';
viewProposalData(entityGuid: any, productCd)
{
    let selectedProductInEdit = {}
    selectedProductInEdit['productId'] = productCd;
    this.policyService.getPolicyByGuid(entityGuid).
      subscribe(resp => {
        this.transactionDataIO = resp;
        let DO = this.commonUtilty.getDOName(this.transactionDataIO);
        if(DO && resp && resp[DO] && resp[DO]['statusCd'] == "INFORCE"){
          this.proposalDataModal = 'Policy Details'; 
        }else{
          this.proposalDataModal = 'Proposal Details';
        }
        this.refreshViewPolicyData();
        // this.interactService.sendIOToTransaction(serviceTask, this.productFamilyCd, selectedProductInEdit, this.proposalType, transactionDataIO, this.productFamilyCd);
        this.viewProposalModal=true;
      });
      
}
viewProposalModal = false;

refreshViewPolicy : boolean = true;
refreshViewPolicyData(){
  this.refreshViewPolicy = false;
  setTimeout(() => {
    this.refreshViewPolicy = true;
  }, 500);
}
getDateString(rawDate) {
  let dateString;

  if (rawDate != null && Array.isArray(rawDate)) {
    const [year, month, day] = rawDate;
    const momentDate = moment({ year, month: month - 1, day });
    const normalizedDate = momentDate.add(1, 'day');
    dateString = normalizedDate.format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
  } else {
    dateString = 'N/A';
  }
  return dateString;
}
}
